import { ComponentUtil } from '../../utils/ComponentUtil';
import { Hooks } from '../../types/Hooks';

ComponentUtil.loader(
  !!document.querySelector(Hooks.FileInput),
  () => import('./FileInput'),
  (FileInput) => {
    ComponentUtil.binder(Hooks.FileInput, FileInput);
  },
);
